import { NgModule } from '@angular/core';

import { DeslocamentosComponent } from './deslocamentos.component';
import {SharedModule} from "../../shared/shared.module";
import {DeslocamentosRoutingModule} from "./deslocamentos-routing.module";
import {DeslocamentoApiService} from "./shared/deslocamento-api.service";
import {DeslocamentoNavigationService} from "./shared/deslocamento-navigation.service";
import {DeslocamentoService} from "./shared/deslocamento.service";
import {DeslocamentoFormComponent} from "./deslocamento-form/deslocamento-form.component";
import {DeslocamentoListComponent} from "./deslocamento-list/deslocamento-list.component";
import {DelocamentoDetailComponent} from './delocamento-detail/delocamento-detail.component';
import {PontosModule} from "../pontos/pontos.module";
import {PassageirosModule} from "../passageiros/passageiros.module";
import {DeslocamentoHistoryComponent} from "./deslocamento-history/deslocamento-history.component";
import {DeslocamentoTableComponent} from "./deslocamento-table/deslocamento-table.component";
import {CustoDeslocamentoFormListComponent} from "./custo-deslocamento-form-list/custo-deslocamento-form-list.component";
import {DeslocamentoCalendarComponent} from "./deslocamento-calendar/deslocamento-calendar.component";
import {OdometrosHorimetrosModule} from "../../manutencoes/odometros-horimetros/odometros-horimetros.module";

@NgModule({
    imports: [
        SharedModule,
        PontosModule,
        PassageirosModule,
        OdometrosHorimetrosModule,
        DeslocamentosRoutingModule
    ],
    providers: [
        DeslocamentoApiService,
        DeslocamentoNavigationService,
        DeslocamentoService
    ],
    declarations: [
        DeslocamentosComponent,
        DeslocamentoFormComponent,
        DeslocamentoListComponent,
        DelocamentoDetailComponent,
        DeslocamentoHistoryComponent,
        DeslocamentoCalendarComponent,
        DeslocamentoTableComponent,
        CustoDeslocamentoFormListComponent
    ],
    exports: [
        DeslocamentoTableComponent,
        CustoDeslocamentoFormListComponent
    ]

})
export class DeslocamentosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/deslocamentos.module.ts
 **/